import { useState } from "react";
import { Input } from "@/components/ui/input";

export const ClientInput = ({ value, onChange, names }) => {
  const [open, setOpen] = useState(false);
  const q = value.trim().toLowerCase();
  const matches = names.filter((n) => n.toLowerCase().includes(q) && n.toLowerCase() !== q).slice(0, 6);

  return (
    <div className="relative">
      <Input
        id="client_name"
        value={value}
        autoComplete="off"
        placeholder="Ex.: Condomínio Jardim Azul"
        onChange={(e) => { onChange(e.target.value); setOpen(true); }}
        onFocus={() => setOpen(true)}
        onBlur={() => setTimeout(() => setOpen(false), 150)}
        className="h-11 bg-slate-950"
        data-testid="client-autocomplete-input"
      />
      {open && matches.length > 0 && (
        <ul className="absolute z-50 mt-1 w-full overflow-hidden rounded-lg border border-slate-700 bg-slate-900 shadow-2xl" data-testid="client-suggestions">
          {matches.map((n, i) => (
            <li key={n}>
              <button
                type="button"
                onMouseDown={() => { onChange(n); setOpen(false); }}
                className="w-full px-3 py-2 text-left text-sm hover:bg-slate-800"
                data-testid={`client-suggestion-${i}`}
              >
                {n}
              </button>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
};
